import { render, staticRenderFns } from "./SdgWrapper.vue?vue&type=template&id=647579e9&scoped=true&"
import script from "./SdgWrapper.vue?vue&type=script&lang=js&"
export * from "./SdgWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SdgWrapper.vue?vue&type=style&index=0&id=647579e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647579e9",
  null
  
)

export default component.exports